


































































































































































































import {
  apiGroupBuyingActivityCommodityList,
  apiGroupBuyingActivityIndex,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { makeUniGoods, Track, UniGoods } from '@/utils'
import { navigateTo } from '@/router'
import { XWaterfallLoad } from '@/components'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '拼团首页',
        }))
      }

      query = useQuery<{
        /** 拼团活动ID */
        id: string
      }>()

      pageData = useApi(() =>
        apiGroupBuyingActivityIndex({
          activityId: this.query.id,
        }),
      )

      isEnded = computed(() => !this.pageData.data.hasActivity)

      groupIndex = ref(0)

      groupData = computed(() =>
        this.pageData.data.groupList!.map((item, index) => ({
          label: item.groupName,
          value: index,
          icon: item.groupImage,
          id: item.groupId,
        })),
      )

      loadData: XWaterfallLoad = ({ pageNumber }) =>
        apiGroupBuyingActivityCommodityList({
          activityId: this.query.id,
          groupId: this.groupData.value[this.groupIndex.value].id,
          pageIndex: pageNumber,
          pageSize: 10,
        }).then(res => makeUniGoods(res.list!))

      handleRuleClick = () => {
        dcb.navigateTo({
          url: this.pageData.data.ruleUrl!,
        })
      }

      handleGoodsClick = (item: UniGoods) => {
        navigateTo('GoodsIndex', {
          id: item.id,
        })
      }

      handleSearchClick = () => {
        navigateTo('SearchEntry')
      }
    },
)
